import {
  EditIcon,
  EyeIcon,
  SendIcon,
  TrashIcon,
} from "../assets/Icon/headerCicon";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

export const OPTIONS = [
  {
    name: "View",
    icon: <EyeIcon />,
  },
  {
    name: "Send",
    icon: <SendIcon />,
  },
  {
    name: "Copy invoice",
    icon: <SendIcon />,
  },
  {
    name: "Edit",
    icon: <EditIcon />,
  },
  {
    name: "Delete",
    icon: <TrashIcon />,
  },
];

export const CUSTOM_OPTIONS = [
  {
    name: "View",
    icon: <EyeIcon />,
  },
  {
    name: "Copy URL",
    icon: (
      <ContentCopyIcon
        sx={{
          mr: -0.5,
          color: "#2977CC",
          width: "18px",
        }}
      />
    ),
  },
  {
    name: "Edit",
    icon: <EditIcon />,
  },
  {
    name: "Delete",
    icon: <TrashIcon />,
  },
];

export const currencyOptions = [{ id: 1, name: "USD", value: "USD" }];

export const taxFilingOptions = [{ id: 1, name: "LLC",value: "LLC+$200.00" },
  { id: 2, value: "C-Corp+$200.00",name: "C-Corp" },
  // { id: 3, value: "Empty Filing I didnt have any revenue-$200.00",name: "Empty Filing I didnt have any revenue" },
 ];
// Base member data with original prices
export const baseMemberData = [
  { id: 1, name: "Add 1 Member", price: 0.00, value: "Add 1 Member $0.00" },
  { id: 2, name: "Add 2 Members", price: 200.00, value: "Add 2 Members $200.00" },
  { id: 3, name: "Add 3 Members", price: 400.00, value: "Add 3 Members $400.00" },
  { id: 4, name: "Add 4 Members", price: 600.00, value: "Add 4 Members $600.00" },
  { id: 5, name: "Add 5 Members", price: 800.00, value: "Add 5 Members $800.00" },
  { id: 6, name: "Add 6 Members", price: 1000.00, value: "Add 6 Members $1000.00" },
];

// Function to calculate dynamic member prices based on selected option
export const getDynamicMemberData = (selectedId: number | null = null) => {
  if (selectedId === null) {
    return baseMemberData;
  }

  const selectedOption = baseMemberData.find(item => item.id === selectedId);
  if (!selectedOption) {
    return baseMemberData;
  }

  const selectedPrice = selectedOption.price;

  return baseMemberData.map(item => {
    const adjustedPrice = item.price - selectedPrice;
    const priceText = adjustedPrice === 0 ? "" : 
                     adjustedPrice > 0 ? `+$${adjustedPrice.toFixed(2)}` : 
                     `$${adjustedPrice.toFixed(2)}`;
                     
    
    return {
      ...item,
      price: item.price, // Keep original price for total calculation
      displayPrice: adjustedPrice, // Use adjusted price for display
      value: `${item.name} ${priceText}`.trim()
    };
  });
};

// Default export for backward compatibility
export const totalMember = baseMemberData;

// Base ITIN data with original prices
export const baseMemberITINData = [
  { id: 1, name: "All members already have an ITIN", price: null, value: "All members already have an ITIN " },
  { id: 2, name: "Add 1 ITIN", price: 100.00, value: "Add 1 ITIN $100.00" },
  { id: 3, name: "Add 2 ITINs", price: 200.00, value: "Add 2 ITINs $200.00" },
  { id: 4, name: "Add 3 ITINs", price: 300.00, value: "Add 3 ITINs $300.00" },
  { id: 5, name: "Add 4 ITINs", price: 400.00, value: "Add 4 ITINs $400.00" },
  { id: 6, name: "Add 5 ITINs", price: 500.00, value: "Add 5 ITINs $500.00" },
  { id: 7, name: "Add 6 ITINs", price: 600.00, value: "Add 6 ITINs $600.00" },
];

// Function to calculate dynamic ITIN prices based on selected option
export const getDynamicMemberITINData = (selectedId: number | null = null) => {
  if (selectedId === null) {
    return baseMemberITINData;
  }

  const selectedOption = baseMemberITINData.find(item => item.id === selectedId);
  if (!selectedOption || selectedOption.price === null) {
    return baseMemberITINData;
  }

  const selectedPrice = selectedOption.price;
  return baseMemberITINData.map(item => {
    if (item.price === null) {
      // Keep "All members already have an ITIN" as is
      return item;
    }
    
    const adjustedPrice = item.price - selectedPrice;
    const priceText = adjustedPrice === 0 ? "$0.00" : 
                     adjustedPrice > 0 ? `+$${adjustedPrice.toFixed(2)}` : 
                     `$${adjustedPrice.toFixed(2)}`;
    
    return {
      ...item,
      price: item.price, // Keep original price for total calculation
      displayPrice: adjustedPrice, // Use adjusted price for display
      value: `${item.name} ${priceText}`.trim()
    };
  });
};

// Default export for backward compatibility
export const totalMemberITIN = baseMemberITINData;

export const businessExpenses = [
  { name: 'advertising', label: 'Advertising (USD)', hint: 'You can leave as 0 if you do not have.' },
  { name: 'commissions_fees', label: 'Commissions and Fees (USD)', hint: 'You can leave as 0 if you do not have.' },     
 
  { name: 'contract_labor', label: 'Contract Labor (USD)', hint: 'You can leave as 0 if you do not have.' },
  { name: 'insurance', label: 'Insurance(other than health) (USD)', hint: 'You can leave as 0 if you do not have.' },
  // { name: 'insurance', label: 'Payments to other Income (USD)', hint: 'You can leave as 0 if you do not have.' },
  { name: 'interest_bank', label: 'Interest(paid to banks,etc) (USD)', hint: 'You can leave as 0 if you do not have.' },
  { name: 'legal_professional', label: 'Legal and Professional Services (USD)', hint: 'You can leave as 0 if you do not have.' },
  {name:'office_expenses', label: 'Office Expenses (USD)', hint: 'You can leave as 0 if you do not have.' },
  // { name: 'other_expenses', label: 'Other Expenses (USD)', hint: 'You can leave as 0 if you do not have.' },
  { name: 'pension_profit_sharing', label: 'Pension and Profit-Sharing (USD)', hint: 'You can leave as 0 if you do not have.' },
  { name: 'rent_lease_vehicles', label: 'Rent or Lease: Vehicles, Machinery and equipment, Other bussiness property (rent) (USD)', hint: 'You can leave as 0 if you do not have.' },
  { name: 'repairs_maintenance', label: 'Repairs and Maintenance (USD)', hint: 'You can leave as 0 if you do not have.' },
  { name: 'supplies_materials', label: 'Supplies (technology/software) (USD)', hint: 'You can leave as 0 if you do not have.' },
  { name: 'supplies_stationary', label: 'Supplies (furniture) (USD)', hint: 'You can leave as 0 if you do not have.' },
  { name: 'taxes_licenses', label: 'Taxes and Licenses (USD)', hint: 'You can leave as 0 if you do not have.' },
  { name: 'travel_meals', label: 'Travel and Meals (50% Countable ) (USD)', hint: 'You can leave as 0 if you do not have.' },
  { name: 'utilities', label: 'Utilities (USD)', hint: 'You can leave as 0 if you do not have.' },
  { name: 'wages', label: 'Wages (USD)', hint: 'You can leave as 0 if you do not have.' },
  { name: 'other_business', label: 'Other (USD)', hint: 'You can leave as 0 if you do not have.' }
];
export const personalIncomeFields = [
  { name: 'personal_gross_income', label: 'Personal Gross Income (USD)', hint: 'You can leave as 0 if you do not have.' },
   { name: 'interest_income', label: 'Taxable Interest Income (USD)', hint: 'You can leave as 0 if you do not have.' },
   { name: 'tax_exempt_interest', label: 'Tax-exempt Interest Income(USD )', hint: 'You can leave as 0 if you do not have.' },
   { name: 'qualified_dividends', label: 'Qualified Dividends Income (USD)', hint: 'You can leave as 0 if you do not have.' },
   { name: 'taxable_refunds', label: 'Taxable refunds,credits,or off offsets of state and local income taxes(USD)', hint: 'You can leave as 0 if you do not have.' },
   { name: 'scholarship_fellowship_grants', label: 'Scholarship and fellowship grants (USD)', hint: 'You can leave as 0 if you do not have.' },
   { name: 'capital_gain_loss', label: 'Capital Gain or Loss (USD)', hint: 'You can leave as 0 if you do not have.' },
   { name: 'other_gains_losses', label: 'Other Gains or Losses (USD)', hint: 'You can leave as 0 if you do not have.' },
   { name: 'ira_distributions', label: 'IRAs, Pensions and Annuities (USD  )', hint: 'You can leave as 0 if you do not have.' },
   { name: 'pensions_annuities', label: 'Rental real estate,royalities,patnerships,trusts,etc.(USD)', hint: 'You can leave as 0 if you do not have.' },
   { name: 'farm_income_loss', label: 'Farm Income or Loss (USD)', hint: 'You can leave as 0 if you do not have.' },
   { name: 'unemployment_compensation', label: 'Unemployment Compensation (USD)', hint: 'You can leave as 0 if you do not have.' },
   { name: 'other_income', label: 'Other Income (USD)', hint: 'You can leave as 0 if you do not have.' }
 ];